/**
 * Full-size photo viewer for .round-photo thumbnails, shown as an in-page
 * overlay rather than a link navigation. Round photos are `data:` URLs, and
 * the previous design opened them via `<a href target="_blank">` — on at
 * least one real device, navigating a new tab to that data URL froze the
 * browser and then crashed the whole tab. This avoids that entirely: no
 * navigation, no new browsing context, just the same already-decoded image
 * shown bigger over the current page.
 */

let overlay: HTMLDivElement | undefined;

function close(): void {
  overlay?.remove();
  overlay = undefined;
}

function open(src: string): void {
  close();
  const el = document.createElement('div');
  el.className = 'lightbox-overlay';
  el.innerHTML = `<img class="lightbox-img" src="${src}" alt="Full-size recognition photo" />`;
  el.addEventListener('click', close);
  document.body.appendChild(el);
  overlay = el;
}

/** Wires up tap-to-enlarge for every current and future .round-photo thumbnail. Call once at startup. */
export function initPhotoLightbox(): void {
  document.addEventListener('click', (e) => {
    const target = (e.target as HTMLElement).closest<HTMLImageElement>('.round-photo');
    if (target?.src) open(target.src);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}
